import { Component } from '@angular/core';
import { AbstractWidgetComponent, WidgetScale, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

@Component({
    selector: 'app-cep-tablet-widget',
    templateUrl: './cep-tablet-widget.component.html',
    styleUrls: ['./cep-tablet-widget.component.scss'],
    standalone: false
})
export class CEPTabletWidgetComponent extends AbstractWidgetComponent  {

  cameraUrl:string = null;

  onSetElementAndContext() {
    if (this.widgetReference.data?.cameraUrl != null) {
      console.log('-----------------', this.widgetReference.data);
      this.cameraUrl = this.widgetReference.data?.cameraUrl;
    }
  }

  onContextChange(contextChange: ContextChange) {
  }

  getScale(): WidgetScale {
    return WidgetScale.normal;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
